import axios from 'axios';
import { useEffect, useState } from 'react';

const GlobalHRSettings = () => {
    const BASE_API_URL = process.env.REACT_APP_API_URL;
    const [companyName, setCompanyName] = useState('');
    const [spaceInfo, setSpaceInfo] = useState(null);

    useEffect(() => {
        // Get user data from cookies
        const getCookie = (name) => {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(';').shift();
        };

        const userCookie = getCookie('user');
        if (userCookie) {
            try {
                const userData = JSON.parse(userCookie);
                if (userData.companyName) {
                    setCompanyName(userData.companyName);
                }
            } catch (error) {
            }
        }
    }, []);

    useEffect(() => {
        if (companyName) {
            axios.get(`${BASE_API_URL}/space-info/${companyName}`)
                .then((response) => {
                    setSpaceInfo(response.data);
                })
                .catch((error) => {
                });
        }
    }, [companyName]);

    return (
        <div style={{
            border: '1px solid #ccc',
            borderRadius: '8px',
            padding: '12px 16px',
            backgroundColor: '#F9F9F9',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontSize: '10px',
            marginRight: '25px',
            marginLeft:'20px'
        }}>
            {spaceInfo ? (
                <span>
                    Jobbox Cloud: Utilised{" "}
                    {parseFloat(spaceInfo.utilizedSpace).toFixed(1)} MB /{" "}
                    {parseInt(spaceInfo.defaultSpace)} GB | &nbsp;
                    <a href="mailto:ping@jobbox.one" style={{ textDecoration: 'underline', color: '#007BFF' }}>
                        Get Additional Credit
                    </a>
                </span>
            ) : (
                <span>Loading space info...</span>
            )}
        </div>
    );
};

export default GlobalHRSettings;
